<script>
	export let width = '200px';
	export let height = '200px';

	let style = `width: ${width}; height: ${height}`;
</script>

<style>
	div {
		display: inline-block;
		margin: 0 auto;
	}
</style>

<div {style}>
	<svg width="100%" height="100%" viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
	    <g transform="matrix(0.7596,0,0,4.94453,-338.705,-1881.19)">
	        <rect x="479.056" y="385.749" width="160.944" height="90.541" style="fill:rgb(255,31,0);stroke:black;stroke-width:1.18px;"/>
	    </g>
	    <g transform="matrix(0.512257,0,0,19.7712,-198.584,-9090.05)">
	        <rect x="720.472" y="462.603" width="173.513" height="19.606" style="fill:rgb(255,153,0);stroke:black;stroke-width:0.15px;"/>
	    </g>
	    <g transform="matrix(0.421476,0,0,20.9478,-48.9064,-13688)">
	        <rect x="769.856" y="656.118" width="210.886" height="18.505" style="fill:rgb(247,227,138);stroke:black;stroke-width:0.14px;"/>
	    </g>
	    <g transform="matrix(0.421476,0,0,20.9478,61.4549,-13688)">
	        <rect x="769.856" y="656.118" width="210.886" height="18.505" style="fill:white;stroke:black;stroke-width:0.14px;"/>
	    </g>
	</svg>
</div>